import { render, staticRenderFns } from "./apex.vue?vue&type=template&id=4c0ce804&"
import script from "./apex.vue?vue&type=script&lang=ts&"
export * from "./apex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports